import {
    VERSION_POLLING_REQUESTED,
    VERSION_POLLING_SUCCEEDED,
    VERSION_POLLING_FAILED,
    VERSION_POLLING_CANCELED
} from './constants';

export function requestPollingVersion() {
    return {
        type: VERSION_POLLING_REQUESTED
    };
}

export function succeededPollingVersion(response: Record<string, any>) {
    return {
        type: VERSION_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingVersion(error: Error) {
    return {
        type: VERSION_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingVersion() {
    return {
        type: VERSION_POLLING_CANCELED
    };
}
